import { useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTerminal } from '@fortawesome/free-solid-svg-icons';
// import './terminalModal.css';

function TerminalModal(props) {
    // list of Commands to be sent to remote computer 
    const [commands, setCommands] = useState([]);

    // Unique input id for input element
    const inputId = `${props.name}-listItem`;
    // Unique input id for ordered list element
    const listId = `${props.name}-list`;

    // Gets the unique input element in terminal modal
    const inputElm = document.getElementById(inputId);
    // Gets the unique ordered list element in terminal modal
    const listElm = document.getElementById(listId);
    // listElm.style.minHeight = "200px";
    // listElm.style.border = "1px white solid";
    // listElm.style.margin = "10px";

    // When the user clicks the button, open the modal 
    const openModal = () => {
        document.querySelector('.modal').style.display = "block";
        document.getElementById(props.name).classList.add('active');
    }

    // When the user clicks on <span> (x), close the modal
    const closeModal = () => {
        document.querySelector(".modal").style.display = "none";
        document.getElementById(props.name).classList.remove('active');
    }

    // Add terminal command to ordered list
    const addItem = () => {
        const item = document.getElementById(`${props.name}-listItem`).value;
        commands.push(item);
        setCommands(commands);

        // Create list item element to add to ordered list
        const li = document.createElement("li");
        li.innerText = item;

        document.getElementById(`${props.name}-list`).append(li);
    }

    // Clear all items in list
    const clearList = () => {
        // Checks if the list of items has any children, if yes then remove all of them
        if(document.getElementById(`${props.name}-list`).hasChildNodes) {
            while(document.getElementById(`${props.name}-list`).firstChild) {
                document.getElementById(`${props.name}-list`).removeChild(document.getElementById(`${props.name}-list`).firstChild);
                commands.shift();
            }
        }
        setCommands(commands);
    }

    // Send Commands to remote computer
    const sendCommands = async () => {
        const type = props.name;
        let url = "";

        if(type.toLowerCase() === "shell") {
            url = `${props.url}/api/shell`;
        } else if(type.toLowerCase() === "terminal") {
            url = `${props.url}/api/terminal`;
        } else {
            console.log("ERROR not a valid type... must be shell or terminal");
            return;
        }

        // Builds Axios request object
        const requestObject = {
            url: url,
            method: "POST",
            headers: {
                apiKey: props.apiKey
            },
            data: {
                cmd: commands
            }
        }

        // Executes API call to remote device
        const apiResponse = await axios(requestObject);

        const output = document.createElement("li");

        // If api call was successful add success message to outputbox
        if(apiResponse.status === 200) {
            output.innerText = "Terminal Success";
            output.style = "background-color: #2eb82e; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px;";
            document.getElementById("outputbox").appendChild(output);
            closeModal();
        } else {
            output.innerText = "Terminal Failed";
            output.style = "background-color: #ff3300; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px";
            document.getElementById("outputbox").appendChild(output);
            closeModal();
        }

    }

    return(
        <>
        <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' style={{borderColor: "#07f22f"}} data-bs-toggle="modal" data-bs-target="#exampleModal" data-toggle="tooltip" data-placement="bottom" title={props.name} onClick={openModal}><FontAwesomeIcon icon={faTerminal} size='2xl' style={{color: "#07f22f"}} /></button>
        {/* <li className="padding-xs bg-color-primary-2 hover-bg-primary-2 hover-cursor align-txt-cntr rounded margin-b-xs" onClick={openModal}>{props.name}</li> */}
        <div id={props.name} className="modal-overlay">
            <div id="modal-content" className="modal">
                {/* <span className="close">&times;</span> */}
                <h2>{props.name}</h2>
                <div className="input-group">
                    <input type="text" id={inputId} placeholder="Enter list item"/>
                    <button id="addBtn" onClick={addItem}>Add</button>
                    <button id="clearBtn" onClick={clearList}>Clear</button>
                </div>
                <ol id={listId}>
                </ol>
                <div className="button-group">
                    <button id="exitBtn" onClick={closeModal}>Exit</button>
                    <button id="sendBtn" onClick={sendCommands}>Send</button>
                </div>
            </div>
        </div>
        </>
    );
}

export default TerminalModal;